import { Box, Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { Avatar } from "../../Avatar";
import { AvatarWrapper, getAvatarBorderLevel } from "../../../Utilities/User";
import { ReasonIcon } from "../../ReasonIcon";

interface IDropdownProps {
  avatar: string;
  callback: (arg0: string) => void;
  username: string;
  reason?: string;
  userGroup?: {
    type: string;
  };
  rank?: number;
  isSelected?: boolean;
  steam?: {
    steamid?: string;
    personaname?: string;
  };
}

const DropdownItem = ({
  avatar,
  callback,
  username,
  reason,
  userGroup,
  rank,
  isSelected = false,
  steam,
}: IDropdownProps) => {
  const avatarBorderLevel = getAvatarBorderLevel({ userGroup, rank });

  const displayName =
    (username !== "User" ? username : steam?.personaname) ?? "User";

  return (
    <Item
      onClick={() => callback(displayName)}
      isSelected={isSelected}
      data-dropdown-item
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" style={{ gap: 10 }}>
          <AvatarWrapper size="tiny" borderLevel={avatarBorderLevel}>
            <Avatar image={avatar} size="tiny" />
          </AvatarWrapper>
          <Text color="ice" fontSize={16} fontWeight={500}>
            {displayName}
          </Text>
        </Flex>
        {reason && <ReasonIcon reason={reason} />}
      </Flex>
    </Item>
  );
};

const Item = styled(Box)<{ isSelected: boolean }>`
  border-radius: 12px;
  cursor: pointer;
  padding: 10px 16px;
  transition: background-color 0.2s;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.gray850 : "transparent"};

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray850};
  }
`;

const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.envy};
  font-size: 16px;
  opacity: 0.8;
  display: flex;
  align-items: center;
`;

export { DropdownItem };
